/* import __COLOCATED_TEMPLATE__ from './compelling-offer-price-message.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { PRICING_5_X_FULL_SEAT_TYPE } from 'embercom/lib/settings/seats/constants';
import type CompellingOfferCampaignService from 'embercom/services/compelling-offer-campaign-service';

interface Signature {
  Args: {
    seatType: string;
    seatPrice: number;
  };
  Blocks: {
    default: [];
  };
}

export default class CompellingOfferPriceMessage extends Component<Signature> {
  @service declare compellingOfferCampaignService: CompellingOfferCampaignService;

  get isCompellingOffer(): boolean {
    return this.compellingOfferCampaignService.isEligibleForCampaignExperience;
  }

  get isFreeSeatsCampaign(): boolean {
    return (
      this.compellingOfferCampaignService.isFreeSeatsCampaign &&
      this.args.seatType === PRICING_5_X_FULL_SEAT_TYPE
    );
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Settings::Teammates::CompellingOfferPriceMessage': typeof CompellingOfferPriceMessage;
    'settings/teammates/compelling-offer-price-message': typeof CompellingOfferPriceMessage;
  }
}
